import React from "react";

// Quedan fijas junto al reporte consultado, no como notificación: los datos que
// se están viendo dependen de que esos turnos o cierres todavía no se cierren.
// Las semanas incompletas van en el mismo bloque porque explican lo mismo: por
// qué el reporte no muestra todo lo que abarca el filtro
export const AdvertenciasReporte = ({ advertencias, semanasIncompletas }) => {
    const mensajes = (advertencias || []).filter(Boolean);
    const semanas = semanasIncompletas || [];

    if (!mensajes.length && !semanas.length) return null;

    return (
        <div className="alert alert-warning text-center font-weight-bold">
            {mensajes.map((mensaje) => (
                <div key={mensaje}>{mensaje}</div>
            ))}

            {semanas.length > 0 && (
                <React.Fragment>
                    <div>
                        Las siguientes semanas no se muestran porque tienen
                        datos incompletos:
                    </div>

                    {semanas.map((semana) => (
                        <div key={`${semana.anio}-${semana.semana}`}>
                            {semana.etiqueta} ({semana.rango}):{" "}
                            {semana.motivos.join("; ")}
                        </div>
                    ))}
                </React.Fragment>
            )}
        </div>
    );
};
